import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Property from "../../components/Listing/Listing";
import houseTest from "../../assets/img/Small-buildings/Front4.jpg";
import { useState, useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Loading from "../../components/Loading/Loading";
import "./BuyRentView.css";
import { Transition } from "react-transition-group";
 import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import { extendTheme } from "@mui/joy/styles";
import BuyImage from "../../assets/img/buyers.png";
import SellImage from "../../assets/img/sellers.png";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import {IconButton} from "@mui/joy";


const theme = extendTheme({
  components: {
    ModalDialog: {
      defaultProps: { layout: "top" },
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.layout === "top" && {
            top: "12vh",
            left: "50%",
            transform: "translateX(-50%)",
          }),
        }),
      },
    },
  },
});

 

const BuyRentView = () => {
  const buyPropertyAction = () => {};
  const navigate = useNavigate();

  const [open, setOpen] = useState(true);
  return (
    <>
      <Navbar />

      <Transition in={open} timeout={400} unmountOnExit >
        {(state) => (
          <Modal
            keepMounted
            open={!["exited", "exiting"].includes(state)}
            onClose={() => setOpen(false)}
            slotProps={{
              backdrop: {
                sx: {
                  opacity: 0,
                  backdropFilter: "none",
                  transition: `opacity 400ms, backdrop-filter 400ms`,
                  ...{
                    entering: { opacity: 1, backdropFilter: "blur(8px)" },
                    entered: { opacity: 1, backdropFilter: "blur(8px)" },
                  }[state],
                },
              },
            }}
            sx={{
              visibility: state === "exited" ? "hidden" : "visible",
            }}
          >
            <ModalDialog
              aria-labelledby="fade-modal-dialog-title"
              aria-describedby="fade-modal-dialog-description"
              theme={theme}
              sx={{
                maxHeight: "85vh",
                minWidth: "60%",
                overflow: "auto",
                opacity: 0,
                transition: `opacity 300ms`,
                ...{
                  entering: { opacity: 1 },
                  entered: { opacity: 1 },
                }[state],
              }}
            >

              <IconButton
              onClick={() => navigate(-1)}
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 10,
                backgroundColor: "#fff",
                borderRadius: "50%",
                boxShadow: 1,
                padding: "4px",
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                }
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>

              {/* login / signup form */}
              <div className="bs-modal-container">
                <div className="caterory-box">
                  <div className="box-image">
                    <img src={BuyImage}></img>
                  </div>
                  <div className="box-title">
                    <h1>Buy A Property</h1>
                  </div>
                  <div className="box-desc">
                    For buyers, our platform offers a personalized search
                    experience that takes into account their unique preferences
                    and priorities. Our AI algorithms can quickly filter through
                    thousands of listings, presenting only the properties that
                    are most likely to meet their needs. This saves time and
                    reduces frustration, as buyers no longer have to sift
                    through dozens of irrelevant listings.
                  </div>
                  <div className="box-action">
                    <Link to="/Buy">
                      <Button variant="contained" size="large">
                        Search Properties
                      </Button>
                    </Link>
                  </div>
                </div>
                <div className="caterory-box">
                  <div className="box-image">
                    <img src={SellImage}></img>
                  </div>
                  <div className="box-title">
                    <h1>Rent A Property</h1>
                  </div>
                  <div className="box-desc">
                    For renters, our platform provides a highly personalized
                    search experience tailored to their specific preferences and
                    priorities. Advanced AI algorithms swiftly filter through
                    thousands of listings to present only the most relevant
                    properties, saving time and reducing frustration.
                    Additionally, the platform offers real-time updates,
                    personalized recommendations, and interactive tools,
                    empowering buyers to make informed decisions with ease and
                    confidence.our platform offers cutting-edge marketing tools
                    designed to highlight your property.
                  </div>
                  <div className="box-action">
                    <Link to="/Rent">
                      <Button variant="contained" size="large">
                        Search Properties
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </ModalDialog>
          </Modal>
        )}
      </Transition>
    </>
  );
};

export default BuyRentView;
